import { FooterCardType } from '../../custom-types/footer';
import { toImage, toLink, toText } from '../../fields';
import { Image } from '../../fields/image';
import { Link } from '../../fields/link';

const simpleCardContainer = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): SimpleCardContainer | undefined => {
  const image = toImage(data?.primary?.image);
  const title = toText(data?.primary?.title);
  const ctaLabel = toText(data?.primary?.ctaLabel);
  const ctaLink = toLink(data?.primary?.ctaLink);

  if (!image || !title || !ctaLink || !ctaLabel) {
    return undefined;
  }

  return {
    type: FooterCardType.SIMPLE,
    image,
    title,
    ctaLabel,
    ctaLink,
  };
};

export type SimpleCardContainer = {
  type: string;
  image: Image;
  title: string;
  ctaLabel: string;
  ctaLink: Link;
};

export default simpleCardContainer;
